const productInstallmentKit = document.querySelector("#taxa-decima-segunda-parcela");

  document.querySelectorAll(".kit-swatches-item").forEach(kit => {
    kit.addEventListener("click", function() {
      const titleProduct = document.querySelectorAll(".product-title")[0];
      const productPriceCompare = document.querySelectorAll(".product-price-compare")[0];
      const productPrice = document.querySelectorAll(".current-price-text-pagina-produto")[0];
      const productDiscount = document.querySelectorAll(".product-discount-percentual")[0];
      const discountParent = document.querySelector("#discount-label");
      const productTaxInstallment = document.querySelector('#tax-installment');
      const productImage = document.querySelector('#product-variant-image');
      const jsonInput = document.querySelector("#data-variants-json");
      const jsonData = JSON.parse(jsonInput.textContent);

      setTimeout(() => {
          const url = window.location.href;
          const numVariant = parseInt(url.split("variant=")[1]);
          jsonData.forEach(item => {
            if(item.id === numVariant) {
  
              if (item.featured_image.src) {
                productImage.style.width = "100px";
                productImage.style.height = "100px";
                productImage.src = item.featured_image.src;
              }
              
              titleProduct.innerText = item.name;
  
              if(item.compare_at_price) {
                const valueComparePrice = (parseInt(item.compare_at_price)/100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' });
                productPriceCompare.innerText = `${valueComparePrice}`;
              }else {
                productPriceCompare.innerText = "";
              }
  
              const valuePrice = (parseInt(item.price)/100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' });
              productPrice.innerText = valuePrice;
  
              if(item.compare_at_price) {
                const value1 = parseFloat(item.compare_at_price);
                const value2 = parseFloat(item.price);
                const discount = Math.round(((value2 - value1) / value1) * 100);
                discountParent.style.display = "flex";
                productDiscount.style.display = "flex";
                productDiscount.innerText = `${discount}%`;
              }else {
                discountParent.style.display = "none";
                productDiscount.style.display = "none";
              }
  
              const installment = (((parseInt(item.price)/100)/12) * parseFloat(productTaxInstallment.value)).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' });
              productInstallmentKit.innerText = `${installment}`;
            }
          })
        }, 200)
    });
  });